import { useState } from 'react'

import {
	EuiButton,
	EuiFieldText,
	EuiFormRow,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'

import CurrencyField from 'components/CurrencyField/currencyField'

import { Group } from '../../index'

export type GroupFormProps = {
	onCancel: () => void,
	onSuccess: () => void,
	onSubmit: ( name: string, spendingLimit?: string ) => Promise<any>,
	selectedGroup?: Group,
	onDeleteClick?: () => void,
}

export default function GroupForm( { onCancel, onSuccess, onSubmit, selectedGroup, onDeleteClick }: GroupFormProps ) {
	const [ groupName, setGroupName ] = useState( selectedGroup?.name ?? '' )
	const [ spendingLimit, setSpendingLimit ] = useState<string>( selectedGroup?.spendingLimit?.toString() ?? '' )
	const [ isSaving, setIsSaving ] = useState( false )

	const isValid = !!groupName

	const handleSubmit = async() => {
		setIsSaving( true )
		await onSubmit( groupName, spendingLimit )
		setIsSaving( false )
		onSuccess()
	}

	return (
		<>
			<EuiModalBody>
				<EuiFormRow label="Group Name">
					<EuiFieldText
						value={groupName}
						onChange={( e: { target: { value: string } } ) => setGroupName( e.target.value )}
					/>
				</EuiFormRow>
				<EuiFormRow label="Spending Limit">
					<CurrencyField
						min={0}
						value={spendingLimit}
						onRawChange={( value: string ) => setSpendingLimit( value )}
					/>
				</EuiFormRow>
			</EuiModalBody>

			<EuiModalFooter>
				{ onDeleteClick !== undefined && (
					<EuiButton
						id="deleteBtn"
						onClick={onDeleteClick}
						color="danger"
					>
						Delete
					</EuiButton>
				) }
				<EuiButton
					id="cancelBtn"
					onClick={onCancel}
					color="text"
				>
					Cancel
				</EuiButton>

				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
					isDisabled={!isValid}
				>
					Save
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
